export default [
    "HTT",
    "HTTF",
    "HTTF_7N7JS",
    "HTTF_7N8JS",

    "PFTT",
    "PFTT_7",
    "PFTT_8",
    "PFTT_7N6JS",
    "PFTT_8N7JS",

    "PFPTT",
    "PFPTT_7",
    "PFPTT_8",
    "PFPTT_7N7JS",
    "PFPTT_7N8JS",
    "PFPTTF",
    "PFPTTF_7",
    "PFPTTF_8",
    "PFPTTF_7N7JS",
    "PFPTTF_7N8JS",
    
    "PFTTF",
    "PFTTF_7",
    "PFTTF_8",
    "PFTTF_7N7JS",
    "PFTTF_7N8JS",

    "PFTTNL",
    "PFTTNL_7", 
    "PFTTNL_8",
    "PFTTNL_7N7JS",
    "PFTTNL_7N8JS",
    
    "PFPTTNL",
    "PFPTTNL_7",
    "PFPTTNL_8",
    "PFPTTNL_7N7JS",
    "PFPTTNL_7N8JS",

    "PFTTUK",
    "PFTTUK_7", 
    "PFTTUK_8",
    "PFTTUK_7N7JS",
    "PFTTUK_7N8JS",
    
    "PFPTTUK",
    "PFPTTUK_7",
    "PFPTTUK_8",
    "PFPTTUK_7N7JS",
    "PFPTTUK_7N8JS",
];